import Paginator from 'components/Pagination';
import React, { useState } from 'react';

type RecentImagedCarouselProps = {
  ImageList;
};

export default function RecentImagedCarousel(props: RecentImagedCarouselProps) {
  const { ImageList } = props;
  const [selectedImageNumber, setSelectedImageNumber] = useState<number>(1);

  return (
    <>
      <div
        id="recentimagedcarousel-image-wrapper"
        className={`border border-black flex align-center content-center justify-center h-[82%] self-center`}
      >
        <img
          id="recentimagedcarousel-image"
          src={ImageList[selectedImageNumber - 1]}
          className="d-block w-100 h-100"
          alt="..."
        />
      </div>
      <Paginator
        pagination={{ perPage: 1, page: selectedImageNumber, total: ImageList.length }}
        onPageNumberChange={(number: number) => setSelectedImageNumber(number)}
        showRowsPerPage={false}
        showSimplifiedVersion
        containerStyle="mt-2 self-center"
      />
    </>
  );
}
